<template>
  <nav class="links">
    <ul>
      <Link v-for="link in links" :key="link.type" :link="link" />
    </ul>
  </nav>
</template>

<script>
  import Link from './Link'

  export default {
    name: 'social',
    components: {
      Link,
    },
    data() {
      return {
        links: [],
      }
    },
    mounted() {
      this.links = [
        {
          type: 'email',
          name: 'sam@mrinalini.dev',
          url: 'sam@mrinalini.dev',
        },
        {
          type: 'linkedin',
          name: 'mrinalini-m',
          url: 'http://linkedin.com/in/mrinalini-m',
        },
        {
          type: 'github',
          name: 'sammndhr',
          url: 'http://github.com/sammndhr',
        },
      ]
    },
  }
</script>

<style lang="scss" scoped>
  nav.links {
    margin: 0.5rem;
    white-space: nowrap;
    align-items: center;
    padding: 0.3rem 0;
    text-align: center;
    width: 100%;
    max-width: 500px;
    margin-top: 3rem;

    ul {
      margin: 0;
      text-align: center;
      justify-items: center;
      display: inline-block;
      display: grid;
      justify-content: center;
      grid-template-columns: repeat(3, minmax(60px, 100px));
      grid-template-areas: 'email linkedin github';
    }
  }
  @include small-breakpoint {
    nav.links {
      margin-top: 5rem;
    }
  }
</style>
